// src/Screens/RecommendedSkillsLoader.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/recommended-skills-loader-animation.json';

const RecommendedSkillsLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/recommended-skills');
    }, 3000); // 3 second loader

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[70vh] w-full max-w-[950px] mx-auto gap-8">
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center">
        Kumar is picking the most useful skills for your dream path...{' '}
        <span role="img" aria-label="brain">🧠</span>
      </p>
    </div>
  );
};

export default RecommendedSkillsLoader;
